import { useMutation } from '@apollo/client';

import {
  SelectCurrencyMutation,
  SelectCurrencyMutationVariables,
} from '../graphql/generated';
import { SELECT_CURRENCY } from '../graphql/mutations';

const useSelectCurrency = () => {
  const [selectCurrency, result] = useMutation<
    SelectCurrencyMutation,
    SelectCurrencyMutationVariables
  >(SELECT_CURRENCY);

  return {
    selectCurrency,
    ...result,
  };
};

export default useSelectCurrency;
